export type TipoBlocoEmail =
  | 'TITULO'
  | 'TEXTO'
  | 'IMAGEM'
  | 'BOTAO'
  | 'VARIAVEL'
  | 'DIVISOR'
  | 'HTML';


export interface BlocoEmail {
  id: string;
  tipo: TipoBlocoEmail;
  recolhido?: boolean;
  texto?: string;
  urlImagem?: string;
  alinhamento?: 'left' | 'center' | 'right';
  largura?: number;
  labelBotao?: string;
  urlBotao?: string;
  corBotao?: string;
  html?: string;
}

export class ModeloEmail {
  assunto = '';
  blocos: BlocoEmail[] = [];
}

export class VariavelEmail {
  nome = '';
  token = '';
  valor = '';

  constructor(nome?: string, valor?: string) {
    this.nome = nome ?? '';
    this.token = nome ? `{{${nome}}}` : '';
    this.valor = valor ?? '';
  }
}

export const ROTULO_BLOCO: Record<TipoBlocoEmail, string> = {
  TITULO: 'Título',
  TEXTO: 'Texto',
  IMAGEM: 'Imagem',
  BOTAO: 'Botão',
  VARIAVEL: 'Variável',
  DIVISOR: 'Divisor',
  HTML: 'HTML colado'
};
